module.exports = __webpack_public_path__ + "static/media/9_kestavaa-teollisuutta.4ed80e3c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/agendaIcons/9_kestavaa-teollisuutta.svg
// module id = ./src/images/agendaIcons/9_kestavaa-teollisuutta.svg
// module chunks = 1